type ProgressInfo = { written: number; total: number }

type UploadBlobParams = {
  absoluteFilePath: string
  url: string
  mimeType?: string
  method?: string
  multipartName?: string
  returnResponse?: boolean
  progressIntervalMilliseconds?: number
  onProgress?: (info: ProgressInfo) => void
}

async function loadBlob(path: string): Promise<Blob> {
  if (path.startsWith("blob:") || path.startsWith("http://") || path.startsWith("https://")) {
    const response = await fetch(path)
    if (!response.ok) throw new Error(`Failed to read file: ${response.status}`)
    return response.blob()
  }
  throw new Error(`Unsupported file path on web: ${path}`)
}

function uploadWithXhr(url: string, formData: FormData, method: string, onProgress?: (info: ProgressInfo) => void) {
  return new Promise<{ response: { data: unknown; status: number } }>((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(method, url)
    xhr.onload = () => {
      let data: unknown = xhr.responseText
      try {
        data = JSON.parse(xhr.responseText)
      } catch {
        /* plain text response */
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ response: { data, status: xhr.status } })
        return
      }
      reject(new Error(`Upload failed with status ${xhr.status}`))
    }
    xhr.onerror = () => reject(new Error("Upload failed"))
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgress?.({ written: event.loaded, total: event.total })
      }
    }
    xhr.send(formData)
  })
}

export default {
  async uploadBlob({
    absoluteFilePath,
    url,
    mimeType = "application/octet-stream",
    method = "POST",
    multipartName = "file",
    onProgress,
  }: UploadBlobParams) {
    const blob = await loadBlob(absoluteFilePath)
    const formData = new FormData()
    const ext = mimeType.split("/")[1] || "bin"
    formData.append(multipartName, blob, `upload.${ext}`)
    return uploadWithXhr(url, formData, method, onProgress)
  },

  async fetchBlob() {
    return { path: "" }
  },
}
